<template>
  <FormContainer>
    <template #title>Présence stagiaires</template>
    <template #content>
      <PresenceBloc :module-index />
    </template>
  </FormContainer>
  <FormContainer withoutDivider>
    <template #title>
      <BasicText
        label="Frais stagiaires"
        size="h4"
        weight="bold"
      />

    </template>
    <template #content>
      <div v-if="!readonly && estTraite" class="addButton">
        <basic-button
          label="Ajouter des frais supplémentaires"
          icon-name="add"
          @click="addFraisSupplementaires"
        ></basic-button>
      </div>
      <BasicAlert
        v-if="metaModule?.$messageErreurDirty!"
        :alertLabel="metaModule?.$messageErreurDirty!"
      />
      <FraisBloc :module-index />
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import FormContainer from '@/features/interface/demande/shared/components/FormContainer.vue'
import { computed } from 'vue'
import { useModuleFrais } from '../useModuleFrais'
import FraisBloc from './blocs/FraisBloc.vue'
import PresenceBloc from './blocs/PresenceBloc.vue'

  const props = defineProps<{
    moduleIndex: number
  }>()

  const state = useModuleFrais(props.moduleIndex)
  const { model, metaModule, readonly, addFraisSupplementaires } = state
  const estTraite = computed(() => model.value?.modules?.at(props.moduleIndex)?.estTraite)

</script>

<style lang="less" scoped>
  @import './StagiaireSection.less';
</style>

